import styled from "styled-components";

import { ReactComponent as CreatorCreditSvg } from "../../../../Assets/CreatorCredit/creator_credit.svg";
import {
  AnimatedTooltip,
  IAnimatedTooltipPosition,
} from "MVVM/Components/AnimatedTooltip";

export const CreatorCreditIcon = ({
  size = 20,
  addMargin = true,
  tooltipPosition = "top" as IAnimatedTooltipPosition,
}) => {
  return (
    <AnimatedTooltip content="Creator Credits" position={tooltipPosition}>
      <StyledCreatorCredit size={size} addMargin={addMargin} />
    </AnimatedTooltip>
  );
};

const StyledCreatorCredit = styled(CreatorCreditSvg)<{
  size: number;
  addMargin: boolean;
}>`
  display: block;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  flex-shrink: 0;
  height: ${(props) => props.size}px;
  overflow: visible;
  width: ${(props) => props.size}px;
  margin-left: ${(props) => (props.addMargin ? "8px" : "0")};
  margin-right: ${(props) => (props.addMargin ? "8px" : "0")};
`;
